import {trans} from '@frontend/helpers'
import {useItemsSearchLocationSelectedHandler} from '@frontend/modules/public/ads/components/search/hooks/useItemsSearchLocationSelectedHandler'
import {useAdsStore} from '@frontend/stores'
import {
    mdiChevronDown,
    mdiMapMarker,
} from '@mdi/js'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {IconButton} from 'swayok-react-mdb-ui-kit/components/Icon/IconButton'
import {Modal} from 'swayok-react-mdb-ui-kit/components/Modal/Modal'
import {useModalControls} from 'swayok-react-mdb-ui-kit/helpers/modals/useModalControls'
import {LocationSelectorModalContent} from './LocationSelectorModalContent'

interface LocationSelectorProps {
    iconMode?: boolean
}

// Компонент для выбора локации для поиска объявлений в ней.
export function LocationSelector(props: LocationSelectorProps) {

    const {
        iconMode,
    } = props

    const location = useAdsStore(
        state => state.searchPanelLocation
    )

    const onLocationChange = useItemsSearchLocationSelectedHandler()

    // Управление состоянием видимости модального окна.
    const {
        openModal,
        closeModal,
        modalProps,
    } = useModalControls()

    return (
        <div>
            {iconMode ? (
                <IconButton
                    path={mdiMapMarker}
                    color="primary"
                    className="offered-items-filter-locations-icon"
                    onClick={openModal}
                />
            ) : (
                <Button
                    color="gray"
                    outline
                    className="btn-offered-items-filter-location-selector d-flex flex-row align-items-center justify-content-start"
                    onClick={openModal}
                >
                    <span className="flex-1">
                        {location?.name ?? trans().common.ads_filter.any_location}
                    </span>
                    <Icon path={mdiChevronDown} />
                </Button>
            )}

            <Modal
                {...modalProps}
                size="lg"
                scrollable
                staticBackdrop
                closeOnEsc
                centered={false}
                dialogId="offered-items-filter-location-picker"
                render={
                    <LocationSelectorModalContent
                        onClose={closeModal}
                        onLocationChange={onLocationChange}
                        currentLocation={location ?? null}
                    />
                }
            />
        </div>
    )
}
